/**
 * AeroVect design-system tokens, scoped to the Tractor State feature.
 *
 * The imported Fleet Console design references these as CSS custom properties
 * (`var(--av-navy)` …) supplied by the AeroVect design system. This app does
 * not load that stylesheet, so the values are resolved to concrete hex/rgba
 * here. Kept in one place so the whole feature stays on-brand and a future
 * global token layer can replace this module wholesale.
 *
 * The colours themselves live in `palette.json` rather than in this file,
 * because two consumers need them and only one of them is TypeScript:
 * styled-components reads them through `tokens`, and `tailwind.config.js`
 * requires the JSON directly to build the Tailwind colour scale the shadcn
 * components are written against. One file, so a brand colour cannot be right
 * in one styling system and stale in the other.
 *
 *   palette.json ─┬─> tokens (styled-components)
 *                 └─> tailwind.config.js (utility classes, shadcn/ui)
 */
import palette from "./palette.json";

export const tokens = {
  // Brand: navy / blue / blueElectric / ink / slate / line / offWhite / white /
  // green. Status text and accents: readyText / groundedText / groundedDot /
  // offlineDot / majorText / toggleOff.
  ...palette,

  // Elevation (effects.css)
  shadowSm:
    "0 1px 2px rgba(34, 42, 53, 0.06), 0 1px 3px rgba(34, 42, 53, 0.08)",
  shadowMd:
    "0 4px 12px rgba(34, 42, 53, 0.08), 0 2px 4px rgba(34, 42, 53, 0.06)",

  // The brand is set in SF Pro Display on Apple hardware; Inter (loaded app-wide)
  // is the neutral fallback elsewhere and carries the light weights the design
  // leans on for big display figures.
  fontSans:
    '"SF Pro Display", -apple-system, BlinkMacSystemFont, "Inter", "Segoe UI", Helvetica, Arial, sans-serif',
  fontMono: 'ui-monospace, Menlo, Monaco, "Cascadia Code", monospace',
} as const;
